import DescriptionIcon from '@mui/icons-material/Description';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { keyframes } from '@mui/system';
import { styled } from '@mui/material/styles';
const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = new Date(date);
    return d.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };


// Define a keyframe animation (e.g., pulse or bounce)
const pulse = keyframes`
  0% {
    transform: scale(1);
    color: #001F3F;
    filter: drop-shadow(0 0 0 rgba(0, 31, 63, 0));
  }
  50% {
    transform: scale(1.15);
    color: #004080; /* Slightly lighter blue */
    filter: drop-shadow(0 0 6px rgba(0, 64, 128, 0.7));
  }
  100% {
    transform: scale(1);
    color: #001F3F;
    filter: drop-shadow(0 0 0 rgba(0, 31, 63, 0));
  }
`;

// Wrap the icon with animation
const AnimatedGiftIcon = styled(CardGiftcardIcon)(({ theme }) => ({
  animation: `${pulse} 1.5s ease-in-out infinite`,
  transformOrigin: 'center',
}));
  export  const menuItems = ({onPlaceOrder, onReport, onHistory,onshowAd})=>[
    { icon: <ShoppingCartIcon />, label: 'Order', onClick: onPlaceOrder },
    { icon: <DescriptionOutlinedIcon />, label: 'Ledger Statement', onClick: onReport },
    { icon: <HistoryIcon />, label: 'History', onClick: onHistory },
    { icon: <AnimatedGiftIcon />, label: 'Ads', onClick: onshowAd },
  ];
  export const getCustomerCardData = (customer) => [
    {
      title: 'Open Order Count',
      value: customer.openOrderCount,
      animate: true,
      icon: <ShoppingCartIcon />,
    },
    {
      title: 'Open Order Value',
      value: customer.openSaleOrderValue,
      animate: true,
      icon: <DescriptionIcon />,
      formatter: (val) => val?.toLocaleString('en-IN'),
    },
    {
      title: 'Last Payment Date',
      value: formatDate(customer.lastPaymentDate),
      animateDate: true,
      icon: <CalendarMonthOutlinedIcon />,
    },
    {
      title: 'Last Payment',
      value: customer.lastPaymentAmount != null ? customer.lastPaymentAmount : null,
      icon: <CurrencyRupeeIcon />,
      formatter: (val) => val != null ? `Rs. ${val.toLocaleString('en-IN')}` : 'N/A',
    },
    
    {
      title: 'Last Invoice Date',
      value: formatDate(customer.lastInvoicedDate),
      icon: <CalendarMonthOutlinedIcon />,
    },
    {
      title: 'Last Invoice Value',
      value: customer.lastInvoicedValue ?? 'N/A',
      icon: <AccountBalanceIcon />,
      formatter: (val) => val?.toLocaleString('en-IN'),
    },
    {
      title: 'Outstanding',
      value: customer.balance ?? 'N/A',
      icon: <AccountBalanceIcon />,
      formatter: (val) => val?.toLocaleString('en-IN'),
    },
    {
      title: 'Credit Limit',
      value: customer.creditLimit,
      animate: true,
      icon: <CurrencyRupeeIcon />,
      formatter: (val) => val?.toLocaleString('en-IN'),
    },
  ];


  // DashboardUtils.js

export const COLORS = ['#4CAF50', '#FFC107', '#FF5722', '#9C27B0'];
export const EMPTY_DATA = [{ name: 'No Data', value: 1 }];
export const EMPTY_COLOR = ['#e0e0e0'];

export const generateAgeingData = (customer) => {
  if (!customer) return [];

  const keys = ['aged30Days', 'aged45Days', 'aged75Days', 'agedMoreThan75Days'];
  const labels = ['0-30 days', '31-45 days', '46-75 days', '>75 days'];

  return keys.map((key, index) => ({
    name: labels[index],
    value: customer[key],
  }));
};

export const getTotalValue = (data) =>
  data.reduce((sum, item) => sum + item.value, 0);

export const generateStepperItems = (data) =>
  data.map((item, index) => ({
    name: item.name,
    value: item.value,
    color: COLORS[index % COLORS.length],
  }));
